import axios from "axios";
import {BASE_URL_GRAPH} from "../Config/globalParams";

// Récupérer l'accessToken de profil utilisateur
export const getAccessToken = (msalInstance,activeAccount) => {
  return new Promise((resolve) => {
        const accessTokenRequest = {
          account: activeAccount,
        };
        // Tenter de récupérer le token d'accès de manière silencieuse
        msalInstance
          .acquireTokenSilent(accessTokenRequest)
          .then((response) => {
            resolve(response.accessToken); // Résoudre avec le token d'accès
          })
          .catch((error) => {
            console.error(
              "Erreur lors de l'obtention du token d'accès :",
              error
            );
            resolve();
          });
      })
    
};

//récupérer la photo d'agent
export const getAgentPhoto = (userId, accessToken) => {
  return new Promise((resolve) => {
    try {
      const url = `${BASE_URL_GRAPH}/users/${userId}/photo/$value`;

      axios
        .get(url, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "image/jpg",
          },
          responseType: "blob",
        })
        .then((response) => {
          if (response.status === 200) {
            // Si la requête réussie, créez un objet URL pour l'image
            const imageUrl = URL.createObjectURL(response.data);
            resolve(imageUrl);
          } else {
            // Si l'image n'est pas trouvée ou autre problème, retourne null
            resolve(null);
          }
        })
        .catch((error) => {
          resolve(null)
        });
    } catch (error) {
      // En cas d'erreur dans la logique de la fonction, retourner null
      resolve(null);
    }
  });
};
//récupérer la présence du profile
export const getProfilePresence = (accessToken) => {
  return new Promise((resolve) => {
    const url = `https://graph.microsoft.com/v1.0/me/presence`;
    axios
      .get(url, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        resolve(response.data); 
      })
      .catch((error) => {
        console.error("Erreur lors de la récupération de la présence :", error);
        resolve(); 
      });
  });
};



//récupérer la présence des agents
export const getAgentsPresence = (userIds, accessToken) => {
  return new Promise((resolve) => {
    const url = `${BASE_URL_GRAPH}/communications/getPresencesByUserId`;
    axios
      .post(
        url,
        {
          ids: userIds, 
        },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
          },
        }
      )
      .then((response) => resolve(response.data))
      .catch((error) => {
        console.error('Erreur lors de la récupération de la présence de l’utilisateur:', error);
        resolve();
      });
  });
};


//les données d'agent
export const getAgentsData = (accessToken, userIds) => {
  return new Promise((resolve) => {
    const url = `${BASE_URL_GRAPH}/$batch`;
    const batchRequests = userIds.map((userId, index) => ({
      id: `${index + 1}`,
      method: "GET",
      url: `/users/${userId}`,
    }));
    const requestBody = {
      requests: batchRequests,
    };
    axios
      .post(url, requestBody, {
        headers: {
          Authorization: `Bearer ${accessToken}`, 
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data.responses);
        }
      })
      .catch((error) => {
        console.error(
          "Erreur lors de la requête batch pour récupérer les agents :",
          error
        );
        resolve();
      });
  });
};
